import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface StatCardProps {
  icon: string;
  label: string;
  value: string;
  change: string;
  isPositive: boolean;
}

const StatsOverview = () => {
  const { t } = useLanguage();

  const stats = [
    {
      icon: 'DocumentCheckIcon',
      label: t('dailyDeals.totalDealsCompleted'),
      value: '247',
      change: '+12.5%',
      isPositive: true,
    },
    {
      icon: 'CurrencyDollarIcon',
      label: t('dailyDeals.totalInvestmentValue'),
      value: '$42.8M',
      change: '+18.3%',
      isPositive: true,
    },
    {
      icon: 'ChartBarIcon',
      label: t('dailyDeals.averageROI'),
      value: '24.7%',
      change: '+3.2%',
      isPositive: true,
    },
    {
      icon: 'UserGroupIcon',
      label: t('dailyDeals.activeClients'),
      value: '156',
      change: '+8.1%',
      isPositive: true,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div key={index} className="bg-card rounded-lg shadow-card p-6 border border-border hover:shadow-hover transition-shadow duration-300">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <Icon name={stat.icon as any} size={24} variant="outline" className="text-primary" />
            </div>
            <div className={`flex items-center space-x-1 text-sm font-semibold ${stat.isPositive ? 'text-success' : 'text-error'}`}>
              <Icon name={stat.isPositive ? 'ArrowUpIcon' : 'ArrowDownIcon'} size={16} variant="solid" />
              <span>{stat.change}</span>
            </div>
          </div>
          <h3 className="text-3xl font-heading font-bold text-foreground mb-1">{stat.value}</h3>
          <p className="text-sm text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;